import React from 'react';
import { applyMiddleware, compose, createStore } from 'redux';
import ReactDOM from 'react-dom';
import Page from './components/Page';
import StudyModal from './components/StudyModal';
import { Provider } from 'react-redux';
import step from './reducers';
import { refreshStudies, fetchSites } from './actions/sites';
import thunk from 'redux-thunk';
import * as API from '../api';
import { error, success } from 'plugins/toastr';
import * as CaseApi from 'saas/pco/cases/api';
import $ from 'jquery';
import { getIsDirty } from './reducers/dirty';
import { withCurrentReferer } from 'plugins/contextual-back';
import * as WorkerApi from 'saas/users/api';

// Lots of redundant code with saas/pco/cases/study
function handleStudySchedule(id, store, root) {
  const $multiButton = $('#bt-multi-schedule-study');

  $multiButton.on('click', evt => {
    $multiButton.addClass('loading');

    Promise.all([WorkerApi.getAllWorkers(), CaseApi.getSitesByCase(id)]).then(
      response =>
        displayMultiSiteModal(response[1].filter(s => !s.study_id), response[0])
    );
  });

  function displayMultiSiteModal(sites, workers) {
    $multiButton.removeClass('loading');

    // Handling cancel button
    const onCancel = () => {
      ReactDOM.unmountComponentAtNode(root);
    };

    const saveStudy = (selectedSites, generalState) => {
      $multiButton.addClass('loading');

      // Serialize form
      const data = new FormData();

      const sitesValue = selectedSites.map(s => s.id).join(',');
      data.append('sites', sitesValue);

      if (generalState && !generalState.workerUnknown && generalState.worker) {
        data.append('worker', generalState.worker);
      }
      if (generalState && !generalState.dateUnknown && generalState.date) {
        data.append('studyDate', generalState.date);
      }

      const hideModal = () => {
        onCancel();
        $multiButton.removeClass('loading');
      };

      const $iconContainer = $('#step2iconContainer');
      const $existingIcon = $('#existingStep2Icon');
      const $forms = $('#creation-step-2 form');

      // Schedule study
      CaseApi.scheduleStudy(id, data).then(
        _ => {
          CaseApi.getSitesByCase(id).then(result => {
            const sites = result;
            if (sites && sites.filter(s => !s.study_id).length === 0) {
              $multiButton.hide();
            }
            if ($existingIcon.length === 0) {
              $iconContainer.html(
                '<i class="clock outline icon large" style="position: absolute; top: 5px;  margin-right: 0 right: 0;"></i>'
              );
            }
            store.dispatch(fetchSites(id));
          });
          $forms.addClass('dirty');
          store.dispatch(refreshStudies(id));

          hideModal();
          success('Etude planifiée avec succès');
        },
        err => {
          console.log('Error attempting to schedule case study', err);
          hideModal();
          if (err.res.status === 409) {
            err.res.text().then(message => error(message));
          } else {
            error(
              'Une erreur est survenue pendant la planification de l`étude'
            );
          }
        }
      );
    };

    const saveMultiSiteStudies = (selectedSites, multiSiteState) => {
      $multiButton.addClass('loading');

      const requests = selectedSites.map(site => {
        const siteState = multiSiteState[site.id];

        // Serialize form
        const data = new FormData();

        data.append('sites', site.id);

        if (siteState && !siteState.workerUnknown && siteState.worker) {
          data.append('worker', siteState.worker);
        }
        if (siteState && !siteState.dateUnknown && siteState.date) {
          data.append('studyDate', siteState.date);
        }

        return CaseApi.scheduleStudy(id, data);
      });

      const hideModal = () => {
        onCancel();
        $multiButton.removeClass('loading');
      };

      const $iconContainer = $('#step2iconContainer');
      const $existingIcon = $('#existingStep2Icon');
      const $forms = $('#creation-step-2 form');

      // Schedule study
      Promise.all(requests).then(
        _ => {
          CaseApi.getSitesByCase(id).then(result => {
            const sites = result;
            if (sites && sites.filter(s => !s.study_id).length === 0) {
              $multiButton.hide();
            }
            if ($existingIcon.length === 0) {
              $iconContainer.html(
                '<i class="clock outline icon large" style="position: absolute; top: 5px;  margin-right: 0 right: 0;"></i>'
              );
            }
            store.dispatch(fetchSites(id));
          });
          $forms.addClass('dirty');
          store.dispatch(refreshStudies(id));

          hideModal();
          success('Etude planifiée avec succès');
        },
        err => {
          console.log('Error attempting to schedule case study', err);
          hideModal();
          store.dispatch(fetchSites(id));
          store.dispatch(refreshStudies(id));

          if (err.res.status === 409) {
            err.res.text().then(message => error(message));
          } else {
            error(
              'Une erreur est survenue pendant la planification de l`étude'
            );
          }
        }
      );
    };

    // Handling approve button
    const onApprove = state => () => {
      if (state && state.isMultiSchedule) {
        saveMultiSiteStudies(state.selectedSites, state.bySiteStudySchedule);
      } else if (state) {
        saveStudy(state.selectedSites, state.generalStudySchedule);
      }
    };

    // Display modal
    ReactDOM.render(
      <StudyModal
        sites={sites}
        workers={workers}
        onCancel={onCancel}
        onApprove={onApprove}
      />,
      root
    );
  }
}

export default function bind() {
  const createLogger = require('redux-logger');
  const logger = createLogger({
    collapsed: true,
  });

  const middleware = [thunk, logger];
  const enhancers = [];

  const root = document.getElementById('creation-step-2');
  const modalRoot = document.getElementById('modal-root');
  const id = root.getAttribute('data-id');
  const customerId = root.getAttribute('data-customer');

  const store = createStore(
    step,
    compose(applyMiddleware(...middleware), ...enhancers)
  );

  const dirtyHandler = () => {
    if (getIsDirty(store.getState())) {
      $('#creation-step-2 form').addClass('dirty');
    }
  };

  store.subscribe(dirtyHandler);

  handleStudySchedule(id, store, modalRoot);
  ReactDOM.render(
    <Provider store={store}>
      <Page id={parseInt(id, 10)} customerId={parseInt(customerId, 10)} />
    </Provider>,
    root
  );

  const update = (id, step, next) => {
    const form = store.getState().form.form;
    const diagsArray = Object.keys(form.diags).map(key => {
      return form.diags[key];
    });

    API.update(id, step, { diags: diagsArray }, next).then(res =>
      window.location.replace(withCurrentReferer(res.url))
    );
  };

  const cleanDirty = () => $('#creation-step-2 form').removeClass('dirty');

  const saveButton = document.getElementById('bt-save');
  const saveNextButton = document.getElementById('bt-save-next');
  if (saveButton) {
    const id = saveButton.getAttribute('data-id');
    const step = saveButton.getAttribute('data-step');
    saveButton.onclick = () => {
      cleanDirty();
      update(id, step, false);
    };
  }
  if (saveNextButton) {
    const id = saveNextButton.getAttribute('data-id');
    const step = saveNextButton.getAttribute('data-step');
    saveNextButton.onclick = () => {
      cleanDirty();
      update(id, step, true);
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/index.js